import { createContext } from "react"

// Trainings and special events are opened in separate browser tabs but tracked in the same
// window Map. Their numeric ids live in independent backend id spaces, so a training and a
// special event can share the same id (e.g. both 5) and collide on a raw-number key. Namespace
// the keys so the two never overwrite or focus each other's window.
export const trainingWindowKey = (id: number) => `training-${id}`
export const specialEventWindowKey = (id: number) => `special-event-${id}`
export const challengeWindowKey = (id: number) => `challenge-${id}`

export const ElearningContext = createContext<Map<string, Window>>(new Map())
